import React from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import {
  ModalOverlay,
  ModalWrapper,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalContent,
  InfoText,
  ModalFooter
} from './style';
import { Button } from '../../RegisterFashionOrder/style';

interface CloseSaleFashionModalProps {
  isOpen: boolean;
  orderId: number;
  onClose: () => void;
  onConfirm: () => void;
  onCancelSale: () => void;
  isLoading?: boolean;
}

const CloseSaleFashionModal: React.FC<CloseSaleFashionModalProps> = ({
  isOpen,
  orderId,
  onClose,
  onConfirm,
  onCancelSale,
  isLoading = false
}) => {
  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <ModalOverlay>
      <ModalWrapper>
        <ModalHeader>
          <ModalTitle>Fechar venda - Pedido {orderId}</ModalTitle>
          <CloseButton onClick={onClose}>
            <X size={20} />
          </CloseButton>
        </ModalHeader>

        <ModalContent>
          <InfoText>
            Escolha o destino da venda para o pedido {orderId}:
            <br />
            Você pode concluir a venda (Fechada) ou cancelar a venda (Cancelado).
          </InfoText>
        </ModalContent>

        <ModalFooter>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={onCancelSale} disabled={isLoading}>
            {isLoading ? 'Processando...' : 'Cancelar venda'}
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? 'Processando...' : 'Concluir venda'}
          </Button>
        </ModalFooter>
      </ModalWrapper>
    </ModalOverlay>,
    document.body
  );
};

export default CloseSaleFashionModal;
